import {createContext, useCallback, useMemo, useState} from "react";
import useStorage from "../../../hooks/useStorage";
import LocationsService from "../../../services/locations-service";

export const ProductsLocationContext = createContext({});

export default function ProductsLocationContextProvider({ children }) {
	const [sourceDepot, _setSourceDepot, deleteSourceDepot] = useStorage({key: 'location_source_depot', serialize: true});
	const [productEan, setProductEan, deleteProductEan] = useStorage({key: 'location_product_ean'});
	const [product, _setProduct] = useState(null);
	const [asStock, setAsStock] = useState(false);
	const [editedQuantity, setLocatingQuantity] = useState(null);
	const isStockable = useMemo(() => !product?.isNew && product?.movable, [product]);
	
	const setProduct = useCallback(prodotto => {
		_setProduct(prodotto);
		if (prodotto?.ean13) {
			setProductEan(prodotto.ean13);
		} else {
			deleteProductEan();
		}
	}, [setProductEan, deleteProductEan]);
	
	const setSourceDepot = useCallback(depot => {
		// Quando cambio il deposito di origine,
		// ripulisco l'ultimo prodotto scansionato dallo stato.
		if (depot?.codice !== sourceDepot?.codice) {
			deleteProductEan();
			_setProduct(null);
		}
		return depot
			? _setSourceDepot(depot)
			: deleteSourceDepot()
	}, [_setSourceDepot, deleteSourceDepot, deleteProductEan, sourceDepot?.codice]);
	
	const refreshSourceDepot = useCallback(async () => {
		const depot = await LocationsService.loadDepot(sourceDepot.codice);
		setSourceDepot(depot);
	}, [sourceDepot, setSourceDepot]);
	
	const locatingQuantity = useMemo(() => {
		if (!product) {
			return 0;
		}
		
		return editedQuantity !== null
			? editedQuantity
			: product.qta;
	}, [product, editedQuantity])
	
	const saveLocatedQuantity = async location => await LocationsService.saveLocatedQuantity(
		sourceDepot.codice,
		product.ean13,
		location,
		locatingQuantity,
		asStock
	);
	
	
	const dataModel = {
		sourceDepot,
		setSourceDepot,
		deleteSourceDepot,
		productEan,
		setProductEan,
		deleteProductEan,
		refreshSourceDepot,
		product,
		setProduct,
		asStock,
		setAsStock,
		isStockable,
		locatingQuantity,
		setLocatingQuantity,
		saveLocatedQuantity
	}
	
	return <ProductsLocationContext.Provider value={dataModel}>
		{ children }
	</ProductsLocationContext.Provider>
}
